import { memo } from 'react';
import type { IconProps } from './types';

const VerticalSquaresIcon = ({ iconLabel, color }: IconProps) => {
    return (
        <svg
            width="4"
            height="20"
            viewBox="0 0 4 20"
            data-icon={iconLabel}
            color={color}
        >
            <g>
                <rect height="4" width="4" y="0" x="0" fill="currentColor" />
                <rect height="4" width="4" y="8" x="0" fill="currentColor" />
                <rect height="4" width="4" y="16" x="0" fill="currentColor" />
            </g>
        </svg>
    );
};

export default memo(VerticalSquaresIcon);
